import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const MASK_VALUE = "********"; // Mask değeri

const SettingDomainForm = () => {
  const [apiSettings, setApiSettings] = useState({

    site_domain: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  // API verilerini ilk render’da çek
  useEffect(() => {
    fetchApiData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // API'den verileri çekip, hassas alanları maskeler
  const fetchApiData = async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/api/settings/1`); // id=1 olan kaydı alıyoruz
      console.log("Gelen API Data:", resp.data);
      const data = resp.data || {};


      setApiSettings((prevState) => ({
        ...prevState,
        ...data,
      }));
    } catch (err) {
      console.error("API verisi çekme hatası:", err);
      toast.error("API ayarları alınamadı!");
    }
  };

  // Input değişikliklerini handle etme
  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Hassas alanlarda (password tipi) odaklanınca maskeyi temizle
  const handleSecretFocus = (e) => {
    if (e.target.value === MASK_VALUE) {
      e.target.value = "";
      // Güncelleme state'te de maskeyi kaldırıyoruz
      setApiSettings((prev) => ({
        ...prev,
        [e.target.name]: "",
      }));
    }
  };

  // Kaydet butonuna basınca API'yi güncelle
  const handleSave = async () => {
    try {
      // Backend'e gönderilecek veriyi hazırlarken, eğer alan maskeyi içeriyorsa
      // yani kullanıcı o alanı değiştirmediyse, o alanı güncelleme dışında bırakıyoruz.
      const dataToSave = {
        site_domain: apiSettings.site_domain,  // Sadece bu
      };


      // Diğer hassas alanları da kontrol edebilirsiniz...

      await axios.put(`${BASE_URL}/api/settings/1`, dataToSave);
      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchApiData(); // Güncellenmiş verileri tekrar çek
    } catch (error) {
      console.error("API Bilgileri kaydedilemedi:", error);
      toast.error("Kayıt hatası oluştu!");
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card mb-0">
            <div className="card-body">
             
                    <div className="mb-3">
                    <label className="form-label fw-bold">{getText("LABEL_SITE_DOMAIN")}</label>
                    <input
                        type="text"
                        className="form-control"
                        name="site_domain"
                        value={apiSettings.site_domain || ""}
                        onChange={handleChange}
                        placeholder="https://example.com"
                    />
                    </div>

              {/* KAYDET BUTONU */}
              <div className="d-flex justify-content-center">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" /> {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingDomainForm;
